const cache = new Map();

async function fetchJson(path) {
  if (cache.has(path)) {
    return cache.get(path);
  }
  try {
    const response = await fetch(path);
    if (!response.ok) {
      throw new Error(`Failed to load ${path}: ${response.status}`);
    }
    const data = await response.json();
    cache.set(path, data);
    return data;
  } catch (error) {
    return null;
  }
}

export const dataService = {
  async getIndex() {
    return fetchJson('/data/index.json');
  },

  async getMovie(id) {
    return fetchJson(`/data/movies/${id}.json`);
  },

  async getPerson(id) {
    return fetchJson(`/data/people/${id}.json`);
  },

  async getSong(id) {
    return fetchJson(`/data/songs/${id}.json`);
  },

  async getLocation(id) {
    return fetchJson(`/data/locations/${id}.json`);
  },

  async search(query) {
    if (!query || query.trim().length === 0) return [];
    const index = await this.getIndex();
    if (!index || !index.searchRegistry) return [];

    const normalized = query.toLowerCase().trim();
    return index.searchRegistry.filter(item => {
      const matchTitle = item.title && item.title.toLowerCase().includes(normalized);
      const matchSinhala = item.sinhalaTitle && item.sinhalaTitle.includes(normalized);
      const matchAliases = item.aliases && item.aliases.some(alias => 
        alias.toLowerCase().includes(normalized)
      );
      return matchTitle || matchSinhala || matchAliases;
    });
  }
};
